<template>
    <div class="page">
        <div class="address-container">
            <div class="address-name input-container">
                <iInput
                    :InputMessage="userName"
                    @input-val="inputVal"
                    @input-immediately="immediatelyVal"
                ></iInput>
            </div>
            <div class="address-phone input-container">
                <iInput
                    :InputMessage="userPhone"
                    @input-val="inputVal"
                    @input-immediately="immediatelyVal"
                ></iInput>
            </div>
            <div
                class="address-district input-container"
                :class="detailIsInput ? 'district-normal' : 'district-placeholder'"
                @click="showComp"
            >
                {{ getTotalAddress() }}
            </div>
            <div class="address-detail input-container">
                <textarea
                    v-model="userAddressDetail"
                    placeholder="详细地址"
                    cols="30"
                    rows="5"
                ></textarea>
            </div>
            <div class="user-tips">
                注：请仔细填写并校对以上信息。提交后，本次礼包的收货地址无法更改。。
            </div>

            <div
                @click="confirm"
                class="address-confirm-btn"
                :class="addressCompleted ? 'confirm-btn-select' : 'confirm-btn-unselect'"
            ></div>

            <AddressCOM
                :show="showAddress"
                :areaLimit="isAwardRestricted"
                @close="hide"
                @addressChange="getAddress"
            />

            <Dialog
                :show="showDialog"
                :content="restrictAward + restrictArea + '不支持发货，请重新选择'"
                title="发货限制"
                lefttxt="修改地址"
                righttxt="重选商品"
                @giveupBtn="giveupBtn"
                @continueBtn="continueBtn"
            />
            <Dialog1
                :show="showOverdueDialog"
                title="对不起，您当前存在逾期，请先完成还款。"
                lefttxt="再看看"
                righttxt="去还款"
                @giveupBtn="giveupToRepay"
                @continueBtn="doSomeRepay"
            />
        </div>
    </div>
</template>

<script>
import iInput from './Input';
import AddressCOM from './AddressChoose';
import homemixin from '@common/js/mixin';
import { mapState } from 'vuex';
export default {
    name: 'address',
    components: {
        iInput,
        Dialog: () => import('../../componets/birthday/homeTitleDialog'),
        Dialog1: () => import('../../componets/birthday/homeDialog'),
        AddressCOM,
    },
    mixins: [homemixin],
    data() {
        return {
            currentAddres: '',
            showAddress: false,
            isAwardRestricted: false, // 地区限制
            showDialog: false,
            showOverdueDialog: false,
            restrictArea: '',
            restrictAward: '',
            userName: {
                name: 'name',
                type: '',
                placeholder: '收货人姓名',
                maxLength: 20,
                value: '',
            },
            userPhone: {
                name: 'phone',
                type: 'phone',
                placeholder: '收货人手机号',
                maxLength: 11,
                value: '',
            },

            titleBar: {
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goBack,
                    },
                ],
                titleView: {
                    text: '编辑/确认收货地址',
                    color: '#000000',
                },
                rightView: [],
            },

            detailIsInput: false,
            userAddressDetail: '',
            addressInfo: {
                province: { name: '', code: '' },
                city: { name: '', code: '' },
                area: { name: '', code: '' },
                town: { name: '', code: '' },
            },

            itemInfo: {},
            addressArray: [],
            addressCompleted: false,
        };
    },
    computed: {
        ...mapState('home', ['selectedGift'])
    },
    watch: {
        addressInfo: {
            handler(n, o) {
                if (
                    !this.userName.value.length <= 0 &&
                    /^\d{4}\d{3}\d{4}$/.test(this.userPhone.value) &&
                    this.addressInfo.province.name &&
                    this.userAddressDetail
                ) {
                    this.addressCompleted = true;
                } else {
                    this.addressCompleted = false;
                }
            },
            deep: true,
        },
        userName: {
            handler(n, o) {
                if (
                    !this.userName.value.length <= 0 &&
                    /^\d{4}\d{3}\d{4}$/.test(this.userPhone.value) &&
                    this.addressInfo.province.name &&
                    this.userAddressDetail
                ) {
                    this.addressCompleted = true;
                } else {
                    this.addressCompleted = false;
                }
            },
            deep: true,
        },
        userPhone: {
            handler(n, o) {
                if (
                    !this.userName.value.length <= 0 &&
                    /^\d{4}\d{3}\d{4}$/.test(this.userPhone.value) &&
                    this.addressInfo.province.name &&
                    this.userAddressDetail
                ) {
                    this.addressCompleted = true;
                } else {
                    this.addressCompleted = false;
                }
            },
            deep: true,
        },
        userAddressDetail: {
            handler(n, o) {
                if (
                    !this.userName.value.length <= 0 &&
                    /^\d{4}\d{3}\d{4}$/.test(this.userPhone.value) &&
                    this.addressInfo.province.name &&
                    this.userAddressDetail
                ) {
                    this.addressCompleted = true;
                } else {
                    this.addressCompleted = false;
                }
            },
            deep: true,
        },
    },

    created() {
        this.list = this.$route.query.list;
        this.itemInfo = this.$route.query.item;
        console.log(this.itemInfo);
        this.customeTitle(this.titleBar);
        this.getAddressDetail();
        this.getRestrictArea({ awardKeys: this.list }, 1);
        this.POINT('h5_element_imp', {
            page: 'super-填写收货地址页',
            tgt_event_id: 'h5_ACT_deliveryAddress',
            tgt_name: 'h5-ACT-填写收货地址页',
            url: window.location.href,
        });
    },
    methods: {
        giveupBtn() {
            this.showDialog = false;
        },
        continueBtn() {
            this.showDialog = false;
            this.$router.go(-1);
        },
        goBack() {
            this.$router.go(-1);
        },
        // 获取拼接后的地址
        getTotalAddress() {
            if (this.detailIsInput) {
                return `${this.addressInfo.province.name}${this.addressInfo.city.name}${this.addressInfo.area.name}${this.addressInfo.town.name}`;
            } else {
                return '所在区域';
            }
        },
        getTotalAllAddress() {
            if (this.detailIsInput) {
                return `${this.addressInfo.province.name}${this.addressInfo.city.name}${this.addressInfo.area.name}${this.addressInfo.town.name}****${this.userAddressDetail}`;
            }
        },

        // 地址输入响应
        getAddress(value) {
            this.addressArray = value;
            this.addressInfo.province = value[0];
            this.addressInfo.city = value[1];
            this.addressInfo.area = value[2];
            if (value.length >= 4) {
                this.addressInfo.town = value[3];
            } else {
                this.addressInfo.town = { name: '', code: '' };
            }
            this.detailIsInput = true;
            console.log('addess---', this.addressInfo, this.addressArray);
            this.getRestrictArea(
                {
                    provinceId: this.addressInfo.province.code,
                    cityId: this.addressInfo.city.code,
                    awardKeys: this.list,
                },
                2
            );
            this.hide();
        },
        showComp() {
            this.showAddress = true;
        },
        hide() {
            this.showAddress = false;
        },
        inputVal(name, val) {
            if (name === this.userName.name) {
                this.userName.value = val;
            } else if (name === this.userPhone.name) {
                this.userPhone.value = val;
            }
        },
        customeTitle(titleBar) {
            if (window.PPDWebUI.os.inApp) {
                window.PPDWebUI.CommonService.setNavigation(titleBar);
            } else {
                document.title = titleBar.titleView.text;
            }
        },
        async confirm() {
            if (this.userName.value.length <= 0) {
                this.$toast('姓名不能为空');
                this.toastEleImpEvent('姓名不能为空');
                return;
            } else if (!/^\d{4}\d{3}\d{4}$/.test(this.userPhone.value)) {
                this.$toast('手机号码有误，请重填');
                this.toastEleImpEvent('手机号码有误，请重填');

                return;
            } else if (!this.addressInfo.province.name) {
                this.$toast('区域不能为空');
                this.toastEleImpEvent('区域不能为空');

                return;
            } else {
                if (!this.userAddressDetail) {
                    this.$toast('地址不能为空');
                    this.toastEleImpEvent('地址不能为空');

                    return;
                }
            }
            console.log(this.addressInfo);
            this.getRealAwardAction();
        },
        toastEleImpEvent(content) {
            this.POINT('h5_element_imp', {
                page: 'super-填写收货地址页',
                tgt_event_id: 'h5_ACT_deliveryAddress_toast',
                tgt_name: 'h5-ACT-填写收货地址页-toast',
                param: content,
            });
        },
        // 获取受限地区
        async getRestrictArea(value, type) {
            const response = await this.$http.getRestrictArea(value);
            if (response && response.Result === 200) {
                const Content = response.Content;
                this.isAwardRestricted = Content.isAwardRestricted;
                if (this.isAwardRestricted && type === 2) {
                    this.showDialog = true;
                    this.restrictArea = Content.restrictInfo.restrictArea;
                    this.restrictAward = Content.restrictInfo.restrictAward;
                    this.POINT('h5_element_imp', {
                        page: 'super-填写收货地址页',
                        tgt_event_id: 'h5_ACT_deliveryAddress_popup',
                        tgt_name: 'h5-ACT-填写收货地址页-收货限制弹窗',
                        param: this.restrictAward,
                        param1: this.restrictArea,
                    });
                }
            }
        },
        async getAddressDetail() {
            const res = await this.$http.queryTopOneAddress({
                activityType: this.$activityType,
                channel: this.selectedGift.channel
            });
            if (res && res.Result) {
                if (res.Result === 200) {
                    const Content = res.Content;
                    if (Content) {
                        this.userName.value = Content.receiverName;
                        this.userPhone.value = Content.receiverPhone;

                        if (Content && Content.province) {
                            this.addressInfo.province.name = Content.province;
                            this.addressInfo.province.code = Content.provinceId;

                            this.addressInfo.city.name = Content.city;
                            this.addressInfo.city.code = Content.cityId;

                            this.addressInfo.area.name = Content.area;
                            this.addressInfo.area.code = Content.areaId;

                            this.addressInfo.town.name = Content.town;
                            this.addressInfo.town.code = Content.townId;
                            this.detailIsInput = true;
                            this.userAddressDetail = Content.addressDetail;
                        }
                    }
                    console.log('tag', this.addressInfo);
                    this.$sensors.doTrackH5ElementImp('h5-ACT-地址弹框');
                } else {
                    this.$toast({ position: 'middle', message: res.ResultMessage });
                }
            }
        },
        async getRealAwardAction() {
            const params = {
                awardKey: this.selectedGift.awardKey,
                receiverName: this.userName.value,
                receiverPhone: this.userPhone.value,
                town: this.addressInfo.town.name,
                townId: this.addressInfo.town.code,
                province: this.addressInfo.province.name,
                provinceId: this.addressInfo.province.code,
                city: this.addressInfo.city.name,
                cityId: this.addressInfo.city.code,
                area: this.addressInfo.area.name,
                areaId: this.addressInfo.area.code,
                addressDetail: this.userAddressDetail,
                activityType: this.$activityType,
                channel: this.selectedGift.channel
            };
            console.log(params);
            const res = await this.$http.addAddress(params);
            if (res && res.Result === 200) {
                await this.awardGift(res.Content.addressId);
            } else if (res.Result === 40724) {
                this.$toast({
                    position: 'middle',
                    message: '抱歉该商品暂时无货，建议选择其他礼品'
                });

            } else {
                this.$toast({ position: 'middle', message: res.ResultMessage });
            }
        },
        async awardGift(addressId) {
            const { Result, ResultMessage, Content } = await this.$http.receiveGiftAward({
                activityType: this.$activityType,
                addressId: addressId,
                awardKeys: this.list,
            });
            let trkLevel = window.sessionStorage.getItem('score');
            let trkRequiredLevel = window.sessionStorage.getItem('requiredScore');
            let trkAwardBtnTxt = window.sessionStorage.getItem('awardBtnTxt');

            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_升级礼包领取结果',
                page: 'super-升级礼包领取结果',
                param1: `${trkLevel}`,
                param2: `${trkRequiredLevel}`,
                param3: `${trkAwardBtnTxt}`,
                param4: `${this.list.length}`,
                param5: `${Result === 200 ? '成功' : `失败${ResultMessage}`}`,
            });
            window.sessionStorage.setItem('score', '');
            window.sessionStorage.setItem('requiredScore', '');
            window.sessionStorage.setItem('awardBtnTxt', '');

            if (Result === 200) {
                this.$toast({ message: '领取成功', duration: 2000 });
                this.$router.go(-1);
            } else {
                if (Result === 40708) {
                    this.$toast({
                        message: '领取失败，请前往权益首页查看您当前权益。',
                        duration: 2000,
                    });
                    this.$router.go(-1);
                } else if (Result === 40713) {
                    this.showDialog = true;
                    this.restrictArea = Content.restrictArea;
                    this.restrictAward = Content.restrictAward;
                    this.POINT('h5_element_imp', {
                        page: 'super-填写收货地址页',
                        tgt_event_id: 'h5_ACT_deliveryAddress_popup',
                        tgt_name: 'h5-ACT-填写收货地址页-popup',
                        param: this.restrictAward,
                        param1: this.restrictArea,
                    });
                } else if (Result === 40719) {
                    // 逾期弹窗
                    this.showOverdueDialog = true;
                    this.POINT('h5_element_imp', {
                        page: 'super-升级礼包实物详情',
                        tgt_event_id: 'h5_ACT_swlb_yuqibox',
                        tgt_name: 'h5-ACT-升级礼包实物详情-逾期提示弹窗',
                        param: '',
                    });
                } else if (Result === 40724) {
                    this.$toast({
                        position: 'middle',
                        message: '抱歉，该商品暂时无货，建议选择其他礼品'
                    });

                } else {
                    this.$toast({ message: `${ResultMessage}`, duration: 2000 });
                }
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: `super-实物领取页面`,
                    ret_code: Result,
                    param: ResultMessage,
                    param1: '/growth/award/receiveGiftAwardV2',
                });
            }
        },
        giveupToRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                page: 'super-升级礼包实物详情',
                tgt_event_id: 'h5_ACT_swlb_yuqibox',
                tgt_name: 'h5-ACT-升级礼包实物详情-逾期提示弹窗',
                param: '',
                param1: '再看看',
            });
        },
        doSomeRepay() {
            this.showOverdueDialog = false;
            this.POINT('h5_clk', {
                page: 'super-升级礼包实物详情',
                tgt_event_id: 'h5_ACT_swlb_yuqibox',
                tgt_name: 'h5-ACT-升级礼包实物详情-逾期提示弹窗',
                param: '',
                param1: '去还款',
            });
            this.openLink('ppdloanapp://repayment/index');
        },
        immediatelyVal(name, val) {
            console.log(name, val);
            this.inputVal(name, val);
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';
.detail-css {
    height: 140px;
}
.page {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;

    .address-container {
        background-color: #f7f7f7;
        width: 100%;
        height: 100%;
        position: relative;
        overflow: auto;
        .input-container {
            height: 70px;
            background: #fff;
            width: 100%;
            margin: auto;
            padding: 5px 15px;
        }
        .address-name {
            margin-top: 5px;
        }
        .address-phone {
            margin-top: 1px;
        }
        .address-district {
            display: inline-block;
            line-height: normal;
            text-align: left;
            line-height: 65px;
            letter-spacing: 1px;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .district-placeholder {
            color: #d5d7dd;
        }
        .district-normal {
            color: #514f4f;
        }
        .address-detail {
            margin-top: 1px;
            height: 140px;
            display: flex;
            align-items: flex-start;
            position: relative;
            textarea {
                -webkit-user-select: auto;
                -moz-user-select: auto;
                user-select: auto;
                overflow: hidden;
                resize: none;
                width: 100%;
                height: 100%;
                border: 0;
                line-height: 1.3;
                padding: 0px;
                padding-top: 10px;
                padding-left: 15px;
                .f-16();
                color: #514f4f;
                position: absolute;
                left: 0;
                top: 0;
                border: none;
                outline: none;
            }
            textarea::placeholder {
                color: #d5d7dd;
                .f-16();
                font-weight: normal;
            }
        }
        .user-tips {
            .f-13();
            color: #9b9b9b;
            padding: 0 18px;
            margin-top: 24px;
            line-height: 21px;
        }
        .address-confirm-btn {
            .f-18-bold();
            color: #fff;
            width: 300px;
            height: 50px;
            bottom: 49px;
            margin: auto;
            margin-top: 100px;
            left: 0;
            right: 0;
            line-height: 55px;
            text-align: center;
            border-radius: 10px;
            letter-spacing: 1px;
        }
        .confirm-btn-unselect {
            background-image: url('~@assets/img/save_address_btn_unselect.png');
            background-size: 100% 100%;
        }
        .confirm-btn-select {
            background-image: url('~@assets/img/save_address_btn.png');
            background-size: 100% 100%;
        }
    }
}
</style>
